import React, { Fragment } from "react"
import { Text, View, StyleSheet } from "@react-pdf/renderer"
import formatNumberWithCommas from "../../../../../utils/formatNumberWithCommas"

const styles = StyleSheet.create({
  totalBoxLine: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
  },
})

const PdfTotals = ({ data = {}, amounts = {}, type = "", client = false }) => {

  let discount = data.discount || 0

  // let halfAmount = data[`50_percent_amount`] || 0
  // let paid = data.paid_amount || 0

  let forClientAdd = client ? formatNumberWithCommas(amounts.payAble + amounts.additional || 0) : formatNumberWithCommas(amounts.original + amounts.additional || 0)
  let forClientSimple = client ? formatNumberWithCommas(amounts.payAble || 0) : formatNumberWithCommas(amounts.original || 0)
  return (
    <Fragment>
      <View>
        <Text
          style={{
            width: "100%",
            padding: 5,
          }}
        >
          TOTAL
        </Text>
        <Text
          style={{
            textAlign: "right",
            backgroundColor: "#FAF7F7",
            width: "100%",
            padding: 5,
          }}
        >
          ${" "}
          {type.toLowerCase() === "invoice"
            ? forClientAdd
            : forClientSimple}
        </Text>
      </View>





      {discount ? (
        <View style={styles.totalBoxLine}>
          <Text>DISCOUNT</Text>
          <Text>- ${formatNumberWithCommas(discount)}</Text>
        </View>
      ) : (
        <View />
      )}


      {
        !client && <View style={[styles.totalBoxLine, { borderBottom: "1px solid gray" }]}>
          <Text>Expenses</Text>
          <Text>
            ${formatNumberWithCommas(amounts.payAble)}
          </Text>
        </View>
      }

      <View style={[styles.totalBoxLine, { borderBottom: "1px solid gray" }]}>
        <Text>PAID</Text>
        <Text>
          - ${formatNumberWithCommas(amounts.paid)}
        </Text>
      </View>


      <View style={styles.totalBoxLine}>
        <Text>BALANCE</Text>
        <Text>
          ${" "}
          {type.toLowerCase() === "invoice"
            ? formatNumberWithCommas(amounts.remaining || 0)
            : formatNumberWithCommas(
              amounts.original - amounts.paid - discount || 0
            )}
        </Text>
      </View>
    </Fragment>
  )
}

export default PdfTotals
